import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_CONFIGURE_COMMUNITY')